// pclm-tilelayers-helper.js

/**
 * 
 * 
 * tilelayer interface:
 * [tileLayerName]-[tileLayerId]  | [TileLayerData[url , ...]]
 * 
 * 
 */
var tileLayersManager ={

	_that: null,
	_types:{},
	_properties:{},
	_baseLayers:{},
	_baseLayers_ids:{},
	_overLayers:{},
	_overLayers_ids:{},
	_groups:{},
	_uncontrolledVisibleGroups: {},
	_controls:[],

	init: function(){
		tileLayersManager._that = this;
		tileLayersManager._types={'baselayer':'baselayer','overlay':'overlay'};
	},
	
	initAllTileLayers: function(mapId, tilelayersData, tilesGroups, layersControlDisplay){
		
		
		var tilelayersData = tilelayersData || null;
		this._properties[mapId]=this._properties[mapId] || {};
		this._properties[mapId]['layersControlDisplay']=layersControlDisplay;
		
		tileLayersManager._baseLayers[mapId] = tileLayersManager._baseLayers[mapId] || {}
		tileLayersManager._baseLayers_ids[mapId]= tileLayersManager._baseLayers_ids[mapId]||{};
		tileLayersManager._overLayers[mapId] = tileLayersManager._overLayers[mapId] || {}
		tileLayersManager._overLayers_ids[mapId]= tileLayersManager._overLayers_ids[mapId]||{};
		
		tileLayersManager.setTileLayersControls(mapId);
		
		tileLayersManager.initializeGroups(mapId);
		tileLayersManager.createGroups(mapId, tilesGroups);
		
		tileLayersManager.manageRemoteTileLayersData(mapId);
		
		if (tilelayersData != null){
			tileLayersManager.manageLocalTileLayerData(mapId,tilelayersData);
		}
		
		

	},

	/**
	 * 
	 */
	createTileLayer: function(tileLayerData){
	 	var tilelayerObj = L.tileLayer(tileLayerData.url);
	 	
	 	if (tilelayerObj){
	 		L.Util.setOptions(tilelayerObj, tileLayerData.options);
	 		tilelayerObj.setWordpressId(tileLayerData.properties['id']);
	 		tilelayerObj.setWordpressParents(tileLayerData.properties['parents']);
	 		
	 	}else{
	 		return false;
	 	}
	 	return tilelayerObj;
	},
	/**
	 * 
	 */
	manageLocalTileLayerData: function(mapId,tilelayersData){
		tileLayersManager.manageTileLayersData(mapId, tilelayersData);
	},

	/**
	 * 
	 */
	manageRemoteTileLayersData: function(mapId){
		jQuery.get(pclm_ajax_object.ajaxurl,
				{	
					"nonce": pclm_ajax_object.nonce_tile_layers_data,
					"action":"tile_layers_data",
					"id":mapId
				},
				function(data){
					tileLayersManager.manageTileLayersData(data.id, data.tileLayers);		
				},
				"json"
			);
	},
	
	manageTileLayersData: function(mapId, tileLayersData){
		
		var map = null;
		var firstBaselayerSet = false;
		var tileLayersLinks = []
		map = mapsManager.getMapElt(mapId);		
		
		if (tileLayersData != null){
			
			/*adaptative for previous version about tilelayers parents*/
			if (tileLayersData['links']){
				tileLayersLinks = tileLayersData['links'];
				tileLayersData = tileLayersData['list'];
			}
			
			for (var tilelayerTypeIdx in tileLayersData){
				for (var tileLayerIdx in tileLayersData[tilelayerTypeIdx]){
					
					
					var idxsplitted = tileLayerIdx.split("-");
					var tileLayerIdxName = "";
					var tileLayerIdxNumber = "";
					var tileLayer = null;
					
					if (idxsplitted.length == 2){
						tileLayerIdxName = idxsplitted[0];
						tileLayerIdxNumber = idxsplitted[1];
					}
					
					var buildData = {"name":tileLayerIdxName, "id":tileLayerIdxNumber, "type": tilelayerTypeIdx,"data":tileLayersData[tilelayerTypeIdx][tileLayerIdx]};
					
					if(tileLayersManager._controls.hasOwnProperty(mapId)){ buildData["control"] = tileLayersManager._controls[mapId];}
	
					// get or create tilelayer Element
					switch (tilelayerTypeIdx){

						case 'overlay':
						{
							if (!tileLayersManager.getOverLayer(mapId,tileLayerIdxName)){
								tileLayer = tileLayersManager.setOverLayer(mapId, buildData);
								
							}else{
								tileLayer = tileLayersManager.getOverLayer(mapId, tileLayerIdxName );
							}
							break;
						}
						case 'baselayer':
						default:
						{
							if (!tileLayersManager.getBaseLayer(mapId,tileLayerIdxName)){
								tileLayer = tileLayersManager.setBaseLayer(mapId, buildData);
							}else{
								tileLayer = tileLayersManager.getBaseLayer(mapId, tileLayerIdxName);
							}
							
						}
					}

					if ((tileLayer!=false)&&((firstBaselayerSet == false) || (tilelayerTypeIdx == 'overlay'))){
						
						tileLayer.addTo(map);
						
						if ((firstBaselayerSet == false) && (tilelayerTypeIdx != 'overlay')){
							firstBaselayerSet =true;
						}
					}
					
				}
			}
			
		}
	
	},
	
	
	getBaseLayer: function(mapId, baseLayerName){
		
		if ( mapId == null || baseLayerName == null){
			return false;
		}else{
			if (tileLayersManager._baseLayers.hasOwnProperty[mapId]){
				return tileLayersManager._baseLayers[mapId][baseLayerName];
			}else{
				return false;
			}
		}
	},
	
	setBaseLayer: function(mapId, layerBuildData){
		
		if ( mapId == null || layerBuildData["name"] == null || layerBuildData["id"] == null || layerBuildData["data"] == null ){
			return false;
		}else{
			
			layerBuildData["storage"] = tileLayersManager._baseLayers[mapId];
			layerBuildData["idStorage"] = tileLayersManager._baseLayers_ids[mapId];			
			return tileLayersManager.setLayer(layerBuildData);						
		}

	},
	
	getOverLayer: function(mapId, overLayerName){
		
		if ( mapId == null || overLayerName == null){
			return false;
		}else{
			if (tileLayersManager._overLayers.hasOwnProperty[mapId]){
				return tileLayersManager._overLayers[mapId][overLayerName];
			}else{
				return false;
			}
		}
	},
	
	setOverLayer: function(mapId, layerBuildData){
		
		if ( mapId == null || layerBuildData["name"] == null || layerBuildData["id"] == null || layerBuildData["data"] == null ){
			return false;
		}else{
			
			layerBuildData["storage"] = tileLayersManager._overLayers[mapId];
			layerBuildData["idStorage"] = tileLayersManager._overLayers_ids[mapId];
			return tileLayersManager.setLayer(layerBuildData);			
		}

	},	
	
	setLayer: function(layerBuildData){
				
		var newLayer = tileLayersManager.createTileLayer(layerBuildData["data"]);
		if (newLayer != false){

			layerBuildData["storage"][layerBuildData["name"]] = newLayer;
		
			layerBuildData["idStorage"][layerBuildData["id"]] = layerBuildData["name"];
			
			if (layerBuildData.hasOwnProperty("control")){ tileLayersManager.addLayerToControl(newLayer, layerBuildData);}
		}
		return newLayer;
	},
	
	setTileLayersControls: function(mapId){
				
		mapId = mapId || null;
		
		if (mapId == null){ return false ;}
		
		var map = null;
		map = mapsManager.getMapElt(mapId);
		
		var controlLayerOptions={};
		if (map.options.collapsed){controlLayerOptions["collapsed"]= (map.options.collapsed === "true" );}
		if (map.options.autoZIndex){controlLayerOptions["autoZIndex"]=(map.options.autoZIndex === "true" );}
		if (map.options.hideSingleBase){controlLayerOptions["hideSingleBase"]=(map.options.hideSingleBase === "true" );}
		if (map.options.sortLayers){controlLayerOptions["sortLayers"]=(map.options.sortLayers === "true" );}
		
		
		if (this._properties[mapId]['layersControlDisplay']){
			tileLayersManager._controls[mapId]=L.control.layers(tileLayersManager._baseLayers[mapId], tileLayersManager._overLayers[mapId],controlLayerOptions).addTo(map);
			map.layersControl = tileLayersManager._controls[mapId];
		}
		
	},
	
	addLayerToControl: function(layer,context){
		switch(context['type']){
			case 'overlay':{
				context['control'].addOverlay(layer,context['name']);
				break;
			}
			case 'baselayer':{
				/*default behaviour*/
			}
			default:{
				context['control'].addBaseLayer(layer,context['name']);
			}
		}
		
		
	},

	
	updateTileLayers: function(mapId,newBaseLayersIds,newOverLayersIds){
		
		if(true){
			var rqBaseLayersIds = tileLayersManager.updateBaseLayers(mapId,newBaseLayersIds);
			var rqOverLayersIds = tileLayersManager.updateOverLayers(mapId,newOverLayersIds);
			
			var rqTileLayersIds = Object.assign(rqBaseLayersIds,rqOverLayersIds);
			
			if (rqTileLayersIds){
			jQuery.get(pclm_ajax_object.ajaxurl,
				{
				"nonce": pclm_ajax_object.nonce_tile_layers_data_from_ids,
				"action":"tile_layers_data_from_ids",
				"id":mapId,
				"rq_ids":rqTileLayersIds
				},
				function(data){
					var map = mapsManager.getMapElt(data.id);
					tileLayersManager._baseLayers_ids[data.id] = tileLayersManager._baseLayers_ids[data.id] || [];
					
					if (data.tileLayers != false){
						manageTileLayersData(data.id,data.tileLayers);
//						for (var tileLayerIdx in data.tileLayers){
//							var tileLayer = tileLayersManager.initTileLayer(data.tileLayers[tileLayerIdx]);
//							var idxsplitted = tileLayerIdx.split("-");
//							tileLayersManager._baseLayers[data.id][idxsplitted[0]] = tileLayer;
//							tileLayersManager._baseLayers_ids[data.id][idxsplitted[1]]=idxsplitted[0];
//							tileLayer.addTo(map);
//							tileLayersManager._controls[data.id].addBaseLayer(tileLayer,idxsplitted[0]);
//							
//						}
					}
					
						
				},
				"json");
			}

		}
		else{
			eltToReturn = false;
		}		
	},
	
	updateBaseLayers: function(mapId,newBaselayersId){
//		var rqBaseLayersIds= [];
//	
//		if (tileLayersManager._baseLayers_ids.hasOwnProperty(mapId)){
//			for (var newBaselayerId in newBaselayersId){
//				if(!tileLayersManager._baseLayers_ids[mapId][newBaselayerId]){
//					rqBaseLayersIds.push({'id':newBaselayerId,'type':'baselayer'});
//				}		
//			}			
//		}
//		
//		for(var _baseLayers_id in tileLayersManager._baseLayers_ids[mapId]){
//			if(!newTilelayersId[_baseLayers_id]){
//				var map = mapsManager.getMapElt(mapId);
//				var returned = map.removeLayer(tileLayersManager._baseLayers[mapId][tileLayersManager._baseLayers_ids[mapId][_baseLayers_id]]);
//				tileLayersManager._controls[mapId].removeLayer(tileLayersManager._baseLayers[mapId][tileLayersManager._baseLayers_ids[mapId][_baseLayers_id]]);
//				delete tileLayersManager._baseLayers[mapId][tileLayersManager._baseLayers_ids[mapId][_baseLayers_id]];
//				delete tileLayersManager._baseLayers_ids[mapId][_baseLayers_id];
//			}
//		}
		
		return tileLayersManager.updateLayers(mapId,newOverlayersId,{"layersIds": tileLayersManager._baseLayers_ids, "layers": tileLayersManager._baseLayers, "layerType":'baselayer' });
		
	},
	
	updateOverLayers: function(mapId,newOverlayersId){
//		var rqOverLayersIds= [];
//		
//		if (tileLayersManager._overLayers_ids.hasOwnProperty(mapId)){
//			rqOverLayersIds[mapId]=[];
//			for (var newOverlayerId in newOverlayersId){
//				if(!tileLayersManager._overLayers_ids[mapId][newOverlayerId]){
//					rqOverLayersIds.push({'id':newOverlayerId,'type':'overlay'});
//				}		
//			}			
//		}
//		
//		for(var _overLayers_id in tileLayersManager._overLayers_ids[mapId]){
//			if(!newTilelayersId[_overLayers_id]){
//				var map = mapsManager.getMapElt(mapId);
//				var returned = map.removeLayer(tileLayersManager._overLayers[mapId][tileLayersManager._overLayers_ids[mapId][_overLayers_id]]);
//				tileLayersManager._controls[mapId].removeLayer(tileLayersManager._overLayers[mapId][tileLayersManager._overLayers_ids[mapId][_overLayers_id]]);
//				delete tileLayersManager._overLayers[mapId][tileLayersManager._overLayers_ids[mapId][_overLayers_id]];
//				delete tileLayersManager._overLayers_ids[mapId][_overLayers_id];
//			}
//		}
		
		return tileLayersManager.updateLayers(mapId,newOverlayersId,{"layersIds": tileLayersManager._overLayers_ids, "layers": tileLayersManager._overLayers, "layerType":'overlay' });
	},
	
	updateLayers: function(mapId, newLayersId, context){
		var rqLayersIds= [];
		
		if (context["layersIds"].hasOwnProperty(mapId)){
			var layersIdsStored = context["layersIds"][mapId];
			var layersStored = context["layers"][mapId];
			
			rqLayersIds[mapId]=[];
			/*search for layers not already present */
			for (var newLayerId in newLayersId){
				if(!layersIdsStored[newLayerId]){
					rqLayersIds.push({'id':newLayerId,'type':context["layerType"]});
				}		
			}	
			
			/* remove layers useless and in control */
			for(var layerId in layersIdsStored){
				if(!newLayersId[layerId]){
					var map = mapsManager.getMapElt(mapId);
					var returned = map.removeLayer(layersStored[layersIdsStored[layerId]]);
					tileLayersManager._controls[mapId].removeLayer(layersStored[layersIdsStored[layerId]]);
					delete layersStored[layersIdsStored[layerId]];
					delete layersIdsStored[layerId];
				}
			}
		}else{
			for (var newLayerId in newLayersId){
				rqLayersIds.push({'id':newLayerId,'type':context["layerType"]});
			}
		}
		
		return rqLayersIds;
	},
	
	/****************************************************************/
	/*					Groups management							*/
	/****************************************************************/
	
	initializeGroups: function(mapId){
		this._groups[mapId] = this._groups[mapId] || {};
		this.createGroup(mapId, {"id":"0", "name": "--Aucun--", "parent":false, "control": false, "displayed": true});
		
		mapsManager.getMapElt(mapId).on("layeradd", function(e){
			if (e.layer instanceof L.TileLayer){
				var childGroups = tileLayersManager.isParentGroup(e.layer._map._container.id,e.layer.getWordpressId())
				for (var grpIdx in childGroups){
					if (childGroups[grpIdx].isControllable() == "false" && !e.layer._map.hasLayer(childGroups[grpIdx])){
						e.layer._map.addLayer(childGroups[grpIdx]);
					}
				}
			}
		});
		
		mapsManager.getMapElt(mapId).on("layerremove", function(e){
			if (e.layer instanceof L.TileLayer){
				var childGroups = tileLayersManager.isParentGroup(e.layer._map._container.id,e.layer.getWordpressId())
				for (var grpIdx in childGroups){
					if (childGroups[grpIdx].isControllable() == "false" && e.layer._map.hasLayer(childGroups[grpIdx])){
						e.layer._map.removeLayer(childGroups[grpIdx]);
					}
				}
			}
		});		
		
	},
	
	
	/************************************************************************/
	/*							CRUD groups									*/
	/************************************************************************/
	
	createGroups: function(mapId, groupsData){
		for (var idx in groupsData){
			this.createGroup(mapId,groupsData[idx]);
		}
	},
	
	readGroups: function(mapId, groupsIdx){
		var returnedGroups=[];
		for (var grpIdx in groupsIdx){
			returnedGroups.push(this.readGroup(mapId,groupsIdx[grpIdx]));
		}
		return returnedGroups;
	},
	
	getGroupsList: function(mapId){
		
		return this._groups[mapId];
	},	
	
	updateGroups: function(mapId, groupsData){
		for (var grpIdx in groupsData){
			if (this.hasGroup(mapId, groupsData[grpIdx].getWordpressId())){
				this.updateGroup(mapId, groupsData[grpIdx]);
			}else{
				this.createGroup(mapId, groupsData[grpIdx]);
			}		
		}
	},
	
	deleteGroups: function(mapId, groupsIdx){
		for (var idx in groupsIdx){
			this.deleteGroup(mapId,groupsIdx[idx]);
		}
	},
	
	updateDisplayedGroups: function updateDisplayedGroups(mapId, baseLayer){
		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		var mapElt = getMapElt(mapHtmlId);
		var groupsToUpdate; 
		
		
		mapElt.eachLayer(function(layer){
			
			if (layer instanceof L.FeatureGroup && !layer.isControllable() ){
				
			}
			
		},mapElt)
		groupsToUpdate = tileLayersManager.isParentGroup(mapId, parentOfGroup);
		for (var groupId in groupsToUpdate){
			if (display===true){
				groupsToUpdate[groupId].addTo(mapElt)	
			}else{
				mapElt.removeLayer(groupsToUpdate[groupId]);
			}
			tileLayersManager._uncontrolledVisibleGroups
			
		}		
	},	
	
	
	/************************************************************************/
	/*							CRUD group									*/
	/************************************************************************/
	
	
	/*
	 * Create Group object and implant in control and Map
	 * */
	createGroup: function(mapId, groupData){
		
		// Création du groupe
		var group = this.initGroup(mapId, groupData);
		
		// check de création
		if (group instanceof L.FeatureGroup){
			// si le groupe peut être sélectionné
			if (group.isControllable()){	
				
				tileLayersManager.updateGroupControl(mapId, group.getWordpressId(), "false", group.isControllable());
				
				if (group.isDisplayedByDefault()){
					group.addTo(mapsManager.getMapElt(mapId));
				}
			}else{
				//si le group ne peux être sélectionné{
				var grpParents = group.getParent();				
				
				
				if (grpParents === undefined || grpParents == false){
					group.addTo(mapsManager.getMapElt(mapId));
				}
			}
		}
		
	},
	
	initGroup: function(mapId, groupData){
		var newGroup =  L.featureGroup();
		newGroup.setWordpressId(groupData.id);
		newGroup.setName(groupData.name);
		newGroup.setParent(groupData.parents);
		newGroup.setControllable(groupData.control);
		newGroup.setDisplayedByDefault(groupData.displayed);
		return this._groups[mapId][groupData.id] = newGroup;
		
	},
	
	readGroup: function(mapId, groupIdx){
		if (this.hasGroup(mapId, groupIdx)){
			return this._groups[mapId][groupIdx];
		}else{
			return false;
		}
		
	},
	
	hasGroup: function(mapId, groupId){
		return this._groups[mapId].hasOwnProperty(groupId);
	},
	
	updateGroup: function(mapId, groupData){
		
		if (groupData.id){
			if(this.hasGroup(mapId, groupData.id)){
				
				if(groupData.hasOwnProperty('name')){this._groups[mapId][groupData.id].setName(groupData.name);}
				if(groupData.hasOwnProperty('parent')){this._groups[mapId][groupData.id].setParent(groupData.parent);}
				if(groupData.hasOwnProperty('control')){
					tileLayersManager.updateGroupControl(mapId, groupData.id,this._groups[mapId][groupData.id].isControllable(),  groupData.control)
					this._groups[mapId][groupData.id].setControllable(groupData.control);
						if(groupData.control == true && groupData.hasOwnProperty('displayed') && groupData.displayed == true){
							this._groups[mapId][groupData.id].addTo(mapsManager.getMapElt(mapId));
						}
					}

			}else{
				return this.createGroup(mapId, groupData);
			}
			return this._groups[mapId][groupData.id];
		}else{
			return false;
		}
	},
	
	deleteGroup: function(mapId, groupId){
		if(this.hasGroup(mapId,groupId)){
			// Pour chque layer du group
			this._groups[mapId][groupId].eachLayer(function(layer){
				var isHasGroup = false;
				// Dans chaque group
				for (var grpIdx in groups){
					//Si le layer n'a pas de group
					if (isHasGroup==false){
						isHasGroup = (( groupId != grpIdx ) && (groups[grpIdx].hasLayer(layer)));
					}
				}
				if (isHasGroup==false){
					this.addToGroup(mapId,0,layer);
				}
			});
			var groupRemoved = Object.assign({},this._groups[mapId][groupId]);
			
			
			delete this._groups[mapId][groupId];
		}
		return groupRemoved;
	},
	
	updateGroupControl: function(mapId, groupId, oldControl, newControl){
		
		if (oldControl==newControl){return;}
		var groupModified = this._groups[mapId][groupId];
		if (oldControl=="false" && newControl=="true"){			
			groupModified.removeFrom(mapsManager.getMapElt(mapId));
			tileLayersManager._overLayers[mapId][groupModified.getName()] = groupModified;
			tileLayersManager._overLayers_ids[mapId][groupModified.getWordpressId()] = groupModified.getName();
			tileLayersManager._controls[mapId].addOverlay(groupModified, groupModified.getName());			
		}else{
			groupModified.addTo(mapsManager.getMapElt(mapId));
			delete tileLayersManager._overLayers[mapId][groupModified.getName()];
			delete tileLayersManager._overLayers_ids[mapId][groupModified.getWordpressId()];
			tileLayersManager._controls[mapId].removeLayer(groupModified);
		}
		
	},
	
	
	
	

	
	/************************************************************************/
	/*							CRUD layer in groups						*/
	/************************************************************************/	
	
	
	getFromGroups: function(mapId,layer){
		
		var groupsReturned = [];
		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		if ((this._groups.hasOwnProperty(mapHtmlId)) && (layer != false)){
			for (var grpIdx in this._groups[mapHtmlId]){			
				if (this._groups[mapHtmlId][grpIdx].hasLayer(layer)){groupsReturned.push(grpIdx);}
			}
		}
		return groupsReturned;
	},
	
	addToGroups: function(mapId, groupsId, layer){
		layer = layer || false;
		groupsId = groupsId || ["0"];
		if (groupsId.length == 0){groupsId.push("0")}
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		
		if ((this._groups.hasOwnProperty(mapHtmlId)) && (layer != false)){
			// Pour tous les groupes
			for (var groupId in this._groups[mapHtmlId]){
				//Si le layer n'est pas dans le groupe et qu'il est à y ajouter
				if (!this._groups[mapHtmlId][groupId].hasLayer(layer) && groupsId.indexOf(groupId) != -1){
					this.addToGroup(mapHtmlId,groupId,layer);
				}
				//Si le layer est dans le groupe et qu'il est à y supprimer
				if (this._groups[mapHtmlId][groupId].hasLayer(layer) && groupsId.indexOf(groupId) == -1){
					this.removeFromGroup(mapHtmlId,groupId,layer);
				}				
			}
		}
	},
	
	removeFromGroups: function(mapId, groupsId, layer){
		
		layer = layer || false;
		groupsId = groupsId || [0];
		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		
		if ((this._groups.hasOwnProperty(mapHtmlId)) && (layer != false)){
			for (var grpIds in groupsId){
				if (this._groups[mapHtmlId][groupsId[grpIds]].hasLayer(layer)){
					this._groups[mapHtmlId][groupsId[grpIds]].removeLayer(layer);	
				}
			}
			
		}else{
			return false;
		}
	},	
	removeFromAllGroups: function(mapId, layer){
		
		var groups = [];
		layer = layer || false;
		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		
		if ((this._groups.hasOwnProperty(mapHtmlId)) && (layer != false)){
			for (var grpId in this._groups[mapHtmlId]){
				if (this._groups[mapHtmlId][grpId].hasLayer(layer)){
					this.removeFromGroup(mapHtmlId,grpId,layer);
					groups.push(grpId);
				}
			}
			
			return {"layer":layer, "groups": groups};
			
		}else{
			return false;
		}
	},	
	
	updateInGroups: function(mapId, oldLayer, newLayer){
		newLayer = newLayer || false;
		oldLayer = oldLayer || false;
		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		
		if ((this._groups.hasOwnProperty(mapHtmlId)) && (newLayer != false)  && (oldLayer != false)){
			for (var groupId in this._groups[mapHtmlId]){
				if (this._groups[mapHtmlId].hasOwnProperty(groupId) && this._groups[mapHtmlId][groupId].hasLayer(oldLayer)){
					this.updateInGroup(mapHtmlId, groupId, oldLayer, newLayer);	
				}
			}			
			//else silently dismiss
		}else{
			return false;
		}
	},
	
	
	/************************************************************************/
	/*							CRUD layer in group							*/
	/************************************************************************/		

	addToGroup: function(mapId, groupId, layer){
		
		layer = layer || false;
		groupId = groupId || 0;
		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		
		if ((this._groups.hasOwnProperty(mapHtmlId)) && layer !=false){
			if (!this._groups[mapHtmlId][groupId].hasLayer(layer)){
				this._groups[mapHtmlId][groupId].addLayer(layer);	
			}
			//else silently dismiss
		}else{
			return false;
		}
	},
	
	removeFromGroup: function(mapId, groupId, layer){
		
		layer = layer || false;
		groupId = groupId || 0;
		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		
		if (this._groups.hasOwnProperty(mapHtmlId) && (layer !=false)){
			if (this._groups[mapHtmlId][groupId].hasLayer(layer)){
				this._groups[mapHtmlId][groupId].removeLayer(layer);	
			}
			//else silently dismiss
		}else{
			return false;
		}
	},	
	
	updateInGroup: function(mapId, groupId, oldLayer,newLayer){
//		if (oldLayer.editing){oldLayer.editing.disable();}
//		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
//		
//		var toReEnable = false;
//		var editMode = mapsManager.getDrawManager(mapHtmlId).getDrawControls(mapHtmlId)._toolbars['edit']._modes['edit'];
//		if (editMode.handler._enabled){
//			editMode.handler.disable();
//			toReEnable=true;
//		}			
		if (this._groups.hasOwnProperty(mapHtmlId)){
			this._groups[mapHtmlId][groupId].removeLayer(oldLayer);
			this._groups[mapHtmlId][groupId].addLayer(newLayer);
		}
		
//		if (toReEnable){
//			editMode.handler.enable();
//		}
	},
	
	
	isParentGroup: function isParentGroup(mapId, parentLayerId){
		var returnedGroups = [];		
		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		
		for (var groupId in this._groups[mapHtmlId]){
			if (this._groups[mapHtmlId][groupId].getParent()==parentLayerId){returnedGroups.push(this._groups[mapHtmlId][groupId])}
		}
		
		if (returnedGroups.length > 0){
			return returnedGroups;
			}
		else{
			return false;
			}
		
	},
	
	getOrphanGroups: function getOrphanGroups(mapId){
		var returnedGroups = [];		
		
		var mapHtmlId = mapsManager.getMapHtmlId(mapId);
		
		for (var groupId in this._groups[mapHtmlId]){
			if (this._groups[mapHtmlId][groupId].getParent()==false){returnedGroups.push(this._groups[mapHtmlId][groupId])}
		}
	},
	
	
	
	
	
}

tileLayersManager.init();


/****************************************************************************/
/*								Map MODS									*/
/****************************************************************************/


L.Map.addInitHook(function(){
	
	this.on('baselayerchange', function(e) {
		e.target.layersControl.updateChildrenOverlays(e.layer);
	})
	
	
});


L.Map.include({
	addTileLayerLoadStatut:function(tileLayerId){
		this._tileLayersStatus = this._tileLayersStatus || [];
		this._tileLayersStatus[tileLayerId]='loading';
	},
	
	setTileLayerLoadStatut:function(tileLayerId,tileLayerStatut){
		this._tileLayersStatus = this._tileLayersStatus || [];
		this._tileLayersStatus[tileLayerId] = tileLayerStatut;
		
		if (-1 == this._tileLayersStatus.indexOf('loading')){
			this.fire('alltilesload');
		}
	}
});


/****************************************************************************/
/*								TileLayer MODS								*/
/****************************************************************************/

L.TileLayer.addInitHook(function(){
	
	this.on('loading', function(e) {
		if (this._map){
			this._map.addTileLayerLoadStatut(L.Util.stamp(e.target))
		}
	})
	
	this.on('load', function(e) {
		if (this._map){
			this._map.setTileLayerLoadStatut(L.Util.stamp(e.target),'loaded')
		}
	})
});

L.TileLayer.include({
	getWordpressId:function(){ return this._wpId;},
		
	setWordpressId:function(id){this._wpId = id;},
	
	getName:function(){return this._name;},
		
	setName:function(name){ this._name = name},
	
	getWordpressParents:function(){ return this._parents;},
	
	setWordpressParents:function(parents){
		this._parents = this._parents || [];
		if (Array.isArray(parents)){
			this._parents = this._parents.concat(parents);
			}
		else
		{
			this._parents.push(parents);
		}
	},
});


/****************************************************************************/
/*								LayerGroup MODS								*/
/****************************************************************************/

L.LayerGroup.addInitHook(function(){
	this.setName("Group");
});

L.LayerGroup.include({
	
	getWordpressId:function(){ return this._wpId;},
	
	setWordpressId:function(id){this._wpId = id;},
	
	setName: function(name){
		if (name != ''){
			this._name = name;
		}
	},
	
	getName: function(){
		return this._name;
	},

	setParent: function(parents){
		this._parents = parents;
	},
	
	getParent: function(){
		return this._parents;
	},
	
	isControllable: function(){
		return this._isControllable;
	},
	
	setControllable: function(isControllable){
		this._isControllable = isControllable;
	},
	
	isDisplayedByDefault: function(){
		return this._isDisplayedByDefault;
	},
	
	setDisplayedByDefault: function(isDisplayedByDefault){			

		this._isDisplayedByDefault = isDisplayedByDefault;
	}
	
	
});


/****************************************************************************/
/*							Control.Layers MODS								*/
/****************************************************************************/

L.Control.Layers.addInitHook(function(){
	
	
	this._idleOverlayers=[];
	
});

L.Control.Layers.include({
	
	hasLayer: function(layer){
		return this._layers.hasOwnProperty(layer._leaflet_id);
	},
	
	hasOverlay: function(overlay){
		return (this._layers.hasOwnProperty(layer._leaflet_id) && this._layers[layer._leaflet_id].overlay);
	},
	
	removeOverlays:function(list){
		var layersToRemove = L.layerGroup();
		
		if (list){
			var listIds = list.map(function(v,i,t){return v.layer._wpId;});
		}
		/*search for layers to remove */
		for(var idx in this._layers){
			if (this._layers[idx].overlay == true && ( (!listIds) || (listIds.indexOf(this._layers[idx].layer._wpId) !=-1 ))){
				layersToRemove.addLayer(this._layers[idx].layer);
			}
		} 
		/*remove for layers*/
		layersToRemove.eachLayer(function(layer){
			this._map.removeLayer(layer);
			this.removeLayer(layer);
		},this);
		
	},

	updateChildrenOverlays: function(parentLayer){
		
		var layersToIdle =[];
		var layersToShow =[];
		
		/*find all visible layers to remove*/
		for(var idx in this._layers){
			if (this._layers[idx].overlay == true && ( this._layers[idx].layer.hasOwnProperty("_parents") ) &&  ( this._layers[idx].layer._parents.indexOf(parentLayer._wpId) ==-1 )){
				layersToIdle.push(this._layers[idx]);
			}
		}
		
		var idxFromIdleToShow= [];
		/*find all hidden layers to show*/
		for(var idx in this._idleOverlayers){
			if (this._idleOverlayers[idx].overlay == true && (( this._idleOverlayers[idx].layer._parents.indexOf(parentLayer._wpId) !=-1 ) || !this._layers[idx].layer.hasOwnProperty("_parents"))){
				layersToShow.push(this._idleOverlayers[idx]);
				idxFromIdleToShow.push(this._idleOverlayers[idx].name);				
			}
		}
		
		/*Remove ids to show from idleOverlays*/
		for(var idx in idxFromIdleToShow){
			for( var i = 0; i < this._idleOverlayers.length; i++){ 
			   if ( this._idleOverlayers[i].name === idxFromIdleToShow[idx]) {
				   this._idleOverlayers.splice(i,1);
				   i--;
			   }
			}					
		}
		
		this._idleOverlayers = this._idleOverlayers.concat(layersToIdle);
		
		/* remove all useless overlays*/
		this.removeOverlays(layersToIdle);		
		
		/* add all overlays to show*/
		for (var idx in layersToShow){
			this.addOverlay( layersToShow[idx].layer,layersToShow[idx].name);
		}
		
		return;
	}	
	
})






